import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useForm, Controller } from "react-hook-form";

import MDBox from "@vendor/components/MDBox";
import MDTypography from "@vendor/components/MDTypography";
import MDInput from "@vendor/components/MDInput";
import MDButton from "@vendor/components/MDButton";
import SnackbarComponent from "@vendor/components/Snackbar";
import bgImage from "@assets/images/bg-sign-up-cover.jpeg";
import Coderland from "@assets/images/logos/logo.png";

import { CoverLayout } from "../components/CoverLayout";
import { useRegister } from "../hooks/useRegister";

/** Campos que el formulario registra. Sin resolver, los `rules` por campo si se aplican. */
interface SignUpFormValues {
  name: string;
  surname: string;
  email: string;
  password: string;
  checkbox: boolean;
}

export const SignUpPage = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { mutate: registerUser } = useRegister();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<SignUpFormValues>({
    defaultValues: {
      checkbox: false,
    },
  });

  const handleClose = (_event?: unknown, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const onRegister = (e: SignUpFormValues) => {
    if (!e.email.includes("@dominion-global")) {
      setMessage("Error, debe ser un correo corporativo");
      setOpen(true);
    } else if (!/^[A-Za-z\s]*$/.test(e.name)) {
      setMessage("Error, (Nombre) debe contener solo letras y espacio");
      setOpen(true);
    } else if (!/^[A-Za-z\s]*$/.test(e.surname)) {
      setMessage("Error, (Apellido) debe contener solo letras y espacio");
      setOpen(true);
    } else {
      registerUser(e, {
        onSuccess: (data) => {
          const user = data as { token?: string };
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("token", JSON.stringify(user.token));
          navigate("/inicio");
        },
        onError: (error) => {
          setMessage(error.response?.data?.message || "Ha ocurrido un error interno");
          setOpen(true);
        },
      });
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <SnackbarComponent open={open} handleClose={handleClose} message={message} alert="error" />
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <Grid container spacing={2} sx={{ justifyContent: "center", mt: 1, mb: 2 }}>
            <img src={Coderland} />
          </Grid>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Registro
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={handleSubmit(onRegister)}>
            <MDBox mb={2}>
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MDInput
                    error={!!errors.name}
                    type="text"
                    label="Nombre"
                    variant="standard"
                    fullWidth
                    {...field}
                  />
                )}
              />
              {errors.name && errors.name.type === "required" && (
                <span style={{ fontSize: 12, color: "red" }}>Es requerido</span>
              )}
            </MDBox>
            <MDBox mb={2}>
              <Controller
                name="surname"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MDInput
                    error={!!errors.surname}
                    type="text"
                    label="Apellido"
                    variant="standard"
                    fullWidth
                    {...field}
                  />
                )}
              />
              {errors.surname && errors.surname.type === "required" && (
                <span style={{ fontSize: 12, color: "red" }}>Es requerido</span>
              )}
            </MDBox>
            <MDBox mb={2}>
              <Controller
                name="email"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MDInput
                    error={!!errors.email}
                    type="email"
                    label="Correo"
                    variant="standard"
                    fullWidth
                    {...field}
                  />
                )}
              />
              {errors.email && errors.email.type === "required" && (
                <span style={{ fontSize: 12, color: "red" }}>Es requerido</span>
              )}
            </MDBox>
            <MDBox mb={2}>
              <Controller
                name="password"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MDInput
                    error={!!errors.password}
                    type="password"
                    label="Contraseña"
                    variant="standard"
                    fullWidth
                    {...field}
                  />
                )}
              />
              {errors.password && errors.password.type === "required" && (
                <span style={{ fontSize: 12, color: "red" }}>Es requerido</span>
              )}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                Registrar
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Ya tienes un cuenta?{" "}
                <MDTypography
                  component={Link}
                  to="/"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Inicia Sesión
                </MDTypography>
              </MDTypography>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </CoverLayout>
  );
};
